FiltersMdl.directive( "category", [ '$compile', '$templateCache', function( $compile, $templateCache ) {
	return {
		restrict: 'E',
		replace: true,
		template: $templateCache.get( 'Filters/Categories/Templates/_category.tpl.html' ),
		//scope: {},
		//controller: ['$scope', function( $scope ) {
		//	this.state = 'main.categories';
		//	//console.log($scope);
		//}],
		//controller : '@',
		//name : 'myController',
		//controllerAs: 'category_state',
		//compile: function( element, attrs ) {
		//	return {
		//		pre: function( scope, element, attrs  ) {
		//
		//
		//		},
		//		post: function(scope, element, attrs ) {
		//			element.attr('ui-state', 'main.categories({category_slug: ' + scope.category.slug + '})');
		//			//return $compile(element);
		//		}
		//	}
		//},
		controller: [ '$scope', function( $scope ){
			var states = {
				'color-fans': 'main.categories.families.colors',
				'effect-fans': 'main.categories.families.effects',
				'categories-select': 'main.categories.subcategories'
			};



			this.state = states[ $scope.category.filter_through ];
		}],
		controllerAs: 'category_state',
		//scope: {},
		bindToController: true,
		link: function( scope, element, attrs ) {
			//console.log(scope)
			//vm.category_state = 'main.categories';
			//console.log(myController)
			//console.log(category)
			//this.category_state = 'main.categories';
			//myController.category_state = 'main.categories';

		}
	}
}]);